// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5864":"a0b08d1c71ac7bf1","89764":"2af55f3263bdb46f","92490":"182793944ab8250b","94566":"e985141a315706f2"}[chunkId] + ".css";
};